import type { ImportIssue, ImportIssueSeverity } from '@/api/clientImports/clientImportsApi.types';

export function resolveIssuesForCell(issues: ImportIssue[], column: string): ImportIssue[] {
  return issues.filter(function matchesColumn(issue) {
    return issue.column === column;
  });
}

export function resolveRowLevelIssues(issues: ImportIssue[]): ImportIssue[] {
  return issues.filter(function isRowLevel(issue) {
    return issue.column === null;
  });
}

export function resolveWorstSeverityForIssues(issues: ImportIssue[]): ImportIssueSeverity | null {
  if (issues.length === 0) {
    return null;
  }
  const hasError = issues.some(function isError(issue) {
    return issue.severity === 'error';
  });
  return hasError === true ? 'error' : 'warning';
}
